export const WORK_CATALOGUE_GRID_CODE = 'work-catalogue';
